export const LAYOUT_CONFIG = {
  rankdir: 'TB',
  ranksep: 80,
  nodesep: 100,
  edgesep: 30,
  marginx: 70,
  marginy: 70,
} as const;

export const NODE_SIZES = {
  minimal: { width: 50, height: 30 },
  normal: { width: 180, height: 100 },
} as const;

export const ZOOM_LEVELS = {
  full: 0.3,
  focused: 0.8,
  minimum: 0.4,
  maximum: 2.0,
} as const;
